<template>
  <div class="ShopListLessons">
    <vv-hero :title="t('title')" :asset="masterclassHero" />

    <!-- Vignification masterclasses -->
    <div v-if="vignificationMasterclasses.length" class="pl-2 pr-2">
      <vv-section-title class="SectionTitle">{{ t('vignifactionMasterclasses') }}</vv-section-title>
      <div :class="{ List__Container: true, 'List__Container--small': $mq === 'mobile' }">
        <div
          v-for="(masterclass, index) of vignificationMasterclasses"
          :key="masterclass.id"
          class="ContentTile"
        >
          <content-tile :masterclass-id="masterclass.id" :index="index%2" @click="onTileClick" />
        </div>
      </div>
    </div>

    <!-- Degustateur masterclasses -->
    <div v-if="degustateurMasterclasses.length" class="pl-2 pr-2">
      <vv-section-title class="SectionTitle">{{ t('degustateurMasterclasses') }}</vv-section-title>
      <div :class="{ List__Container: true, 'List__Container--small': $mq === 'mobile' }">
        <div
          v-for="(masterclass, index) of degustateurMasterclasses"
          :key="masterclass.id"
          class="ContentTile"
        >
          <content-tile :masterclass-id="masterclass.id" :index="index%2" @click="onTileClick" />
        </div>
      </div>
    </div>

    <!-- Pays masterclasses -->
    <div v-if="paysMasterclasses.length" class="pl-2 pr-2">
      <vv-section-title class="SectionTitle">{{ t('paysMasterclasses') }}</vv-section-title>
      <div :class="{ List__Container: true, 'List__Container--small': $mq === 'mobile' }">
        <div
          v-for="(masterclass, index) of paysMasterclasses"
          :key="masterclass.id"
          class="ContentTile"
        >
          <content-tile :masterclass-id="masterclass.id" :index="index%2" @click="onTileClick" />
        </div>
      </div>
    </div>

    <!-- Vignes masterclasses -->
    <div v-if="vigneMasterclasses.length" class="pl-2 pr-2">
      <vv-section-title class="SectionTitle">{{ t('vignesMasterclasses') }}</vv-section-title>
      <div :class="{ List__Container: true, 'List__Container--small': $mq === 'mobile' }">
        <div
          v-for="(masterclass, index) of vigneMasterclasses"
          :key="masterclass.id"
          class="ContentTile"
        >
          <content-tile :masterclass-id="masterclass.id" :index="index%2" @click="onTileClick" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get'

import userMixin from '@/mixins/user'
import { VvHero, VvSectionTitle } from '@/components/common'
import ContentTile from '@/components/masterclass/ContentTile'

export default {
  name: 'MasterclassList',
  mixins: [userMixin],
  components: { VvHero, VvSectionTitle, ContentTile },
  computed: {
    masterclassHero() {
      const images = {
        female: 'masterclass_female.jpg',
        male: 'masterclass_male.jpg',
        unknow: 'masterclass_couple.jpg'
      }

      if (!this.user) return images.unknow

      return images[this.user.gender] || images.unknow
    },
    allMasterclassIds() {
      return _get(this.$store.state, 'lesson.theme.allIds', [])
    },
    sortedMasterclasses() {
      return this.allMasterclassIds
        .map(id => this.$store.getters.getThemeById(id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order)
    },
    vignificationMasterclasses() {
      return this.sortedMasterclasses.filter(
        masterclass => masterclass.type === this.$const.masterclassType.VIGNIFICATION
      )
    },
    degustateurMasterclasses() {
      return this.sortedMasterclasses.filter(
        masterclass => masterclass.type === this.$const.masterclassType.DEGUSTATEUR
      )
    },
    paysMasterclasses() {
      return this.sortedMasterclasses.filter(
        masterclass => masterclass.type === this.$const.masterclassType.PAYS
      )
    },
    vigneMasterclasses() {
      return this.sortedMasterclasses.filter(
        masterclass => masterclass.type === this.$const.masterclassType.VIGNE
      )
    }
  },
  methods: {
    t(key, params) {
      return this.$t(`shop.lessons.${key}`, params)
    },
    onTileClick({ id, locked }) {
      if (locked) {
        return this.$router.push({
          name: 'shop-item',
          params: {
            type: 'masterclass',
            productId: id
          }
        })
      }

      this.$router.push({ name: 'theme', params: { themeId: id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.ShopListLessons {
  padding-bottom: 20px;

  .SectionTitle {
    margin-top: 50px;
    margin-bottom: 30px;
  }

  .ContentTile {
    display: inline-block;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
    vertical-align: top;
  }
}

.List__Container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  @media screen and (max-width: 719px) {
    justify-content: center;    
  }
}
</style>
